/**
 * @generated SignedSource<<c54401f478d4056196a3b03c048f64a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsServiceOptionEditPageQuery$variables = {
  id: string;
};
export type SettingsServiceOptionEditPageQuery$data = {
  readonly serviceOption: {
    readonly name: string;
    readonly service: {
      readonly group: {
        readonly id: string;
        readonly name: string;
      };
      readonly id: string;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "ServiceOptionEditForm_serviceOption">;
  } | null;
};
export type SettingsServiceOptionEditPageQuery = {
  response: SettingsServiceOptionEditPageQuery$data;
  variables: SettingsServiceOptionEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Service",
  "kind": "LinkedField",
  "name": "service",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceGroup",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsServiceOptionEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceOption",
        "kind": "LinkedField",
        "name": "serviceOption",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceOptionEditForm_serviceOption"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsServiceOptionEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceOption",
        "kind": "LinkedField",
        "name": "serviceOption",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scoroProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6bff5bb63061247d95d05ce6c56e8ce",
    "id": null,
    "metadata": {},
    "name": "SettingsServiceOptionEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsServiceOptionEditPageQuery(\n  $id: ID!\n) {\n  serviceOption(id: $id) {\n    name\n    service {\n      id\n      name\n      group {\n        id\n        name\n      }\n    }\n    ...EntitySidebar_entity\n    ...ServiceOptionEditForm_serviceOption\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment ServiceOptionEditForm_serviceOption on ServiceOption {\n  id\n  name\n  scoroProductId\n  price\n}\n"
  }
};
})();

(node as any).hash = "70421a92f6af826387781bb5f2505210";

export default node;
